import { PaginationShipment } from '@/domain/entities/Pagination'

export class Subscription {
    public id?: number;
    public name?: string;
    public startDate?: string;
    public endDate?: string;
    public price?: number;
    public discountedPrice?: number;
    public programBannerUrl?: string;
    public activeBannerUrl?: string;
    public benefitFlag?: string[];
    public extraBenefit?: ExtraBenefit;
    public duration?: number;
    public createdAt?: string;
    public updatedAt?: string;
    public createdBy?: number;
    public updatedBy?: number;
    public status?: string;
    public tnc?: string;

    constructor(fields?: Partial<Subscription>) {
        Object.assign(this, fields);
    }
}

export class ExtraBenefit {
    public freeInsurance?: FreeInsurance;
    public onTimeGuarantee?: OnTimeGuarantee;

    constructor(fields?: Partial<ExtraBenefit>) {
        Object.assign(this, fields);
    }
}

export class FreeInsurance {
    public active?: boolean;
    public maxPrice?: number;

    constructor(fields?: Partial<FreeInsurance>) {
        Object.assign(this, fields);
    }
}

export class OnTimeGuarantee {
    public active?: boolean;
    public type?: string;
    public value?: number;
    public disburseOption?: string;

    constructor(fields?: Partial<OnTimeGuarantee>) {
        Object.assign(this, fields);
    }
}

export class Subscriptions {
    public pagination?: PaginationShipment
    public data?: Subscription[]

    constructor(fields?: Partial<Subscriptions>) {
        Object.assign(this, fields);
    }
}